var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { paths } from "frontend/src/pages/paths/index";
import { Role } from "frontend/src/shared/types/role";
import { TimetablesPage } from "./timetables/index";
export var employeeRoutes = [
    {
        path: paths.employee.timetables.index(),
        Component: TimetablesPage,
    },
].map(function (route) { return (__assign(__assign({}, route), { role: Role.BusinessEmployee })); });
